import { render, staticRenderFns } from "./ModalQuestionOptions.vue?vue&type=template&id=be49b708"
import script from "./ModalQuestionOptions.vue?vue&type=script&lang=js"
export * from "./ModalQuestionOptions.vue?vue&type=script&lang=js"
import style0 from "./ModalQuestionOptions.vue?vue&type=style&index=0&id=be49b708&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports